import { useAuthContext } from '@/shared/contexts/AuthContext';

/**
 * Custom hook to check user roles easily in components.
 * Usage: const { isUser, isAdmin, isReviewer, hasRole, hasAnyRole } = useUserRole();
 */
export function useUserRole() {
  const { user } = useAuthContext();
  const roles = user?.roles || [];

  const isUser = roles.includes('user');
  const isAdmin = roles.includes('admin');
  const isReviewer = roles.includes('reviewer');
  const hasRole = (role: string) => roles.includes(role);
  const hasAnyRole = (requiredRoles: string[]) =>
    requiredRoles.some((r) => roles.includes(r));

  return { isUser, isAdmin, isReviewer, hasRole, hasAnyRole, roles };
}
